<template>
  <form-select
    class="version-select-v1"
    v-model="val"
    :options="options"
    @change="change"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'version-select-v1',
  props: {
    versions: Array,
    version: String,
    changIndex: Number,
    value: [String, Number],
  },
  model: {
    prop: 'value',
    event: 'setval',
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      },
    },
  },
  data() {
    return {
      options: [],
      vermap: {},
    }
  },
  methods: {
    calcVersionOptions() {
      var options = []
      this.vermap = []
      for (var item of this.versions) {
        this.vermap[item.version] = item.areas
        options.push({
          packid: item.packid,
          version: item.version,
          label: item.version,
          value: item.version,
        })
      }
      this.options = options
      this.val = null
      if (options.length > 0) {
        this.$nextTick(() => {
          if (this.version != null && this.version != '') {
            for (let option of options) {
              if (option.value == this.version) {
                this.val = option.value
                //console.log('result: ',option)
                this.$emit('outArea', option, this.vermap[option.value])
                return
              }
            }
          }
          this.val = options[0].value
          this.$emit('outArea', options[0], this.vermap[options[0].value])
        })
      }
    },
    change(newVal) {
      for (var item of this.options) {
        if (item.value == newVal) {
          this.$emit('outArea', item, this.vermap[item.value])
        }
      }
    },
  },
  watch: {
    versions() {
      this.calcVersionOptions()
    },
  },
}
</script>
<style lang="less">
.version-select-v1 {
  width: 100px;
}
</style>
